import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Select } from "antd";
import { useSearchParams } from "react-router-dom";

import { selectors as NODE_SELECTORS } from "../../ducks/node";
import { getChannelTestsOutputsIdsSelector } from "../../ducks/nodeChannels";

const SelectOutput = ({ channelId }) => {
  const outputsIdsSelector = useSelector((state) => getChannelTestsOutputsIdsSelector(state, channelId));
  const [searchParams, setSearchParams] = useSearchParams();
  const outputId = +searchParams.get("o") || null;
  const isTestStarted = useSelector(NODE_SELECTORS.getNodeTestStarted);

  const handleChangeOutput = (selectedOutputId) => {
    searchParams.set("o", selectedOutputId);
    setSearchParams(searchParams);
  };

  return (
    <Select
      onChange={handleChangeOutput}
      options={outputsIdsSelector}
      autoFocus
      showSearch
      optionFilterProp="label"
      style={{ width: 200 }}
      value={outputId}
      disabled={isTestStarted}
    />
  );
};

SelectOutput.propTypes = {
  channelId: PropTypes.string,
};

SelectOutput.defaultProps = {
  channelId: null,
};

export default SelectOutput;
